import React, { Component } from 'react';
import PropTypes from 'prop-types';

class VerticalExpander extends Component {
  getStyle() {
    const { height, transitionSpeed } = this.props;
    const style = {};

    if (height === 'auto') {
      style.height = height;
    } else {
      style.height = `${height}px`;
    }
    style.transition = `height ${transitionSpeed}s`;

    return style;
  }

  render() {
    const { expanded, children } = this.props;
    return (
      <div
        className={expanded ? 'expander expanded' : 'expander collapsed'}
        style={this.getStyle()}
      >
        {children}
      </div>
    );
  }
}

VerticalExpander.propTypes = {
  transitionSpeed: PropTypes.number,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

VerticalExpander.defaultProps = {
  transitionSpeed: 1,
  expanded: false,
  height: 0,
};

export default VerticalExpander;
